import {
  Component,
  OnInit,
  ViewChild,
  AfterViewChecked,
  Input,
  Output,
  EventEmitter,
  PipeTransform, Pipe
} from '@angular/core';

declare var $: any;
import * as moment from 'moment';
import {Resource} from '../../../entities/Resource';
import {Priorities, Statuses, Task} from '../../../entities/Task';
import {TimeplanService} from '../../../services/timeplan.service';
import {ResourceTaskTime} from '../../../entities/ResourceTaskTime';
import {environment} from '../../../../environments/environment';
import {Calendar, CalendarFilter} from '../../../entities/Calendar';
import {TaskService} from '../../../services/task.service';
import {TaskPageModel, TaskTypes} from '../../../entities/PageModel';
import {delay} from 'q';

declare var myExtObject: any;

@Component({
  selector: 'app-full-calendar-view',
  templateUrl: './full-calendar-view.component.html',
  styleUrls: ['./full-calendar-view.component.css']
})
export class FullCalendarViewComponent implements OnInit {

  @Input()
  calendar: Calendar = null;

  @Input()
  unPlannedTasks: TaskPageModel;
  @Input()
  plannedTasks: TaskPageModel;

  TaskTypes = TaskTypes;


  public listToShow: string = '2a';
  isDragging: boolean;

  @Input() set _calendar(value: Calendar) {
    this.calendar = value;
    this.rerenderCalendar(value);
  }

  /*@Input()
  externalTasks : any[] = null;*/
  @Input()
  employees: any[];
  @Input()
  chosenEmployee: Resource;

  @Input()
  firstRun: Boolean;

  //Specifiable calendar variables
  @Input()
  defaultView: string;

  @Input() set calendarDate(value: string) {
    if (value != null) {
      (async () => {
        await delay(1000);

        this.changeCalendarDate(value);
      })();
      this.firstRun = false;
    }
  }

  chosenTask: Task;

  searchInput: string;

  @Output()
  updateTaskEmitter = new EventEmitter();

  @Output()
  setEmployeeEmitter = new EventEmitter();

  @Output()
  getTaskEmitter = new EventEmitter();

  @Output()
  updateTimePlanEmitter = new EventEmitter();

  @Output()
  removeEmpTimePlanEmitter = new EventEmitter();

  @Output()
  refreshCurrentTaskListEmitter = new EventEmitter();

  calendarFilter = CalendarFilter.All;

  doWork: boolean;

  StartDate = new Date();

  draggingElement = null;

  constructor(private timePlanService: TimeplanService, private taskservice: TaskService) {
  }

  ngOnInit() {
    this.chosenTask = new Task();
    this.isDragging = false;
  }

  getTasks(taskPageModel: TaskPageModel) {
    taskPageModel.CalendarFilter = this.calendarFilter;

    /*if(this.ChosenJob != null && this.ChosenJob.No != 'Alle sager')
      taskPageModel.JobNo = this.ChosenJob.No;

    if(this.calendarTask != null)
      taskPageModel.TaskNo = this.calendarTask.No;*/
    this.refreshCurrentTaskListEmitter.emit(taskPageModel);

  }

  changeCalendarDate(value) {
    $('#calendar').fullCalendar('changeView', this.defaultView);
    $('#calendar').fullCalendar('gotoDate', new Date(value));

  }

  // Emits the data necesarry data to update a task. Sets relation between chosen employee.
  updateTask(task: Task) {
    this.updateTaskEmitter.emit(task);
  }

  createTimePlanForEmployee(origionalTaskObject: any) {
    return this.timePlanService.createTimePlan({
      TaskRef: origionalTaskObject.TaskRef,
      ResourceRef: this.chosenEmployee.No,
      start: origionalTaskObject.start.format(),
      end: origionalTaskObject.end
    });
  }

  updateTimePlanOnChange(timePlanNo: string, startTime: string, endTime: string) {
    let obj: ResourceTaskTime = {TimePlanRef: timePlanNo, start: startTime, end: endTime, ResourceRef: this.chosenEmployee.No};

    this.updateTimePlanEmitter.emit(obj);
  }


  removeEmployeeTimePlan(timePlanNo: string, taskGuid: string, employeeNo: string) {
    let obj: ResourceTaskTime = {TimePlanRef: timePlanNo, TaskRef: taskGuid, ResourceRef: employeeNo};

    this.removeEmpTimePlanEmitter.emit(obj);
  }

  // Sets the chosen employee
  setEmployee(emp: Resource) {
    if (emp.No != this.chosenEmployee.No) {
      this.setEmployeeEmitter.emit(emp);
    }
  }

  rerenderCalendar(calendar: Calendar) {
    this.StartDate = $('#calendar').fullCalendar('getDate');
    this.doWork = false;
    if (calendar != null) {
      this.doWork = true;
      if (this.doWork == true) {
        $('#calendar').fullCalendar('removeEvents');
      }
      if (this.doWork == true) {
        $('#calendar').fullCalendar('addEventSource', calendar.ResourceTaskTimes);
        this.doWork = false;
      } else {
        this.rerenderCalendar(calendar);
      }
    }
    /*if(calendar != null) {
      $('#calendar').fullCalendar('removeEvents');
      $('#calendar').fullCalendar('addEventSource', calendar.ResourceTaskTimes);

    }*/

  }

  openModal(task: Task) {
    this.chosenTask = Object.assign({}, task);
    $('#myModal').modal('show');
  }


  // Initiaize all the JS funtions and setting necesarry data.
  initJS() {

    $('.btn-group-vertical > .btn').click(function () {
      $(this).addClass('active').siblings().removeClass('active');
    });

    let self = this;

    $('#calendar').fullCalendar({
      schedulerLicenseKey: environment.SCHEDULER_TOKEN,
      locale: 'da',
      timeZone: 'local',
      lazyFetching: true,
      header: {
        left: 'prev,next today',
        center: 'title',
        right: 'month,agendaWeek,agendaDay'
      },
      events: self.calendar.ResourceTaskTimes,
      editable: true,
      aspectRatio: 1.6,
      fixedWeekCount: false,
      handleWindowResize: true,

      droppable: true, // this allows things to be dropped onto the calendar !!!
      dragRevertDuration: 0,
      minTime: '07:00:00',
      maxTime: '18:00:00',
      businessHours: {
        // days of week. an array of zero-based day of week integers (0=Sunday)
        dow: [1, 2, 3, 4, 5], // Monday - Thursday

        start: '07:00', // a start time (10am in this example)
        end: '17:00', // an end time (6pm in this example)
      },

      navLinks: true,
      defaultDate: self.StartDate,


      // This function is called when an external event is dropped
      drop: function (date) {

        // retrieve the dropped element's stored Event Object
        var originalEventObject = $(this).data('eventObject');

        // we need to copy it, so that multiple events don't have a reference to the same object
        var copiedEventObject = $.extend({}, originalEventObject);

        // assign it the date that was reported
        copiedEventObject.start = date;

        if (date.format(environment.END_DATETIME_FORMAT) != environment.DEFAULT_DATETIME_END) {
          // Utc formaterer til local tidsformat - DK = +1
          let end = new Date(date.format());
          let e = moment(end.setHours(end.getHours() + 2));
          copiedEventObject.end = e.format();
        } else {
          copiedEventObject.end = copiedEventObject.start;
        }


        if (copiedEventObject.TaskRef != null) {
          self.createTimePlanForEmployee(copiedEventObject).subscribe(timePlanNo => {
            placeEventInCalendar(copiedEventObject, timePlanNo)
          });
        }
        ;
      },

      // This function is called when a event is dropped inside the calendar
      eventDrop: function (event, delta, revertFunc) {
        if (event.end == null) {
          if (event.start.format(environment.END_DATETIME_FORMAT) == environment.DEFAULT_DATETIME_END) {
            event.end = event.start;
          } else if (self.draggingElement.start.format(environment.END_DATETIME_FORMAT) != environment.DEFAULT_DATETIME_END) {
            event.end = event.start;
            let end = new Date(event.end.utc().format());
            let e = moment(end.setHours(end.getHours() + 2));
            event.end = e;
          } else {

            let start = new Date(event.start.utc().format());
            event.start = moment(start.setHours(start.getHours() - 2));
            event.end = event.start;
            let end = new Date(event.end.utc().format());
            let e = moment(end.setHours(end.getHours() + 2));
            event.end = e;
          }
        }

        self.updateTimePlanOnChange(event.TimePlanRef, event.start, event.end);
        self.setDragging(false);
      },

      // This funtion is called when a event is resized
      eventResize: function (event, delta, revertFunc) {
        //self.dropTaskOnEmployee(self.chosenEmployee.No, event.TaskGUID, event.start, event.end);
        self.updateTimePlanOnChange(event.TimePlanRef, event.start, event.end);
      },

      // This function is called when a event is dropped on the external event list.
      eventDragStop: function (event, jsEvent, ui, view) {
        if (jsEvent != null && event != null) {
          if (isEventOverDiv(jsEvent.clientX, jsEvent.clientY)) {

            var tooltip = '<div class="tooltipDeleteEvent panel panel-default" align="center" ' +
              'style="width:260px;height:260px;position:absolute;' +
              'z-index:10001;border-radius: 6px;box-shadow: 1px 1px 5px"' +
              '><div class="panel-heading"><strong>' + 'Fjern tid?' + '</strong>' +
              '<button type="button" id="cancelActionBtn" class="close cancelAction" data-dismiss="modal">&times;</button></div>' +
              '<div class="panel-body">' +
              '<p>' + 'Er du sikker på at du vil slette tid for ' + '</p><pre>' + event.resourceId + ' </pre>' + '<p>På opgave </p><pre>' + event.title + '</pre>' +
              '<button id="DeleteEventBtn" class="btn btn-primary">Slet</button>' +
              '<button id="CancelDeleteBtn" class="btn btn-default cancelAction" style="margin-left: 20px;">Fortryd</button>' +
              '</div>' +
              '</div>';
            $('body').append(tooltip);
            $(this).css('z-index', 10000);
            $('.tooltipDeleteEvent').fadeIn('500');
            $('.tooltipDeleteEvent').fadeTo('10', 1.9);
            $('.tooltipDeleteEvent').css('top', jsEvent.pageY + -275);
            $('.tooltipDeleteEvent').css('left', jsEvent.pageX + -120);

            $('#DeleteEventBtn').click(function () {

              $('#calendar').fullCalendar('removeEvents', event._id);
              self.removeEmployeeTimePlan(event.TimePlanRef, event.TaskRef, event.ResourceRef);
              $('.tooltipDeleteEvent').remove();
            });
            $('#CancelDeleteBtn').click(function () {
              $('.tooltipDeleteEvent').remove();
            });

            $('.cancelAction').click(function () {
              $('.tooltipDeleteEvent').remove();
            });
          }
          ;
          self.setDragging(false);
        }
      },
      eventMouseover: function (calEvent, jsEvent) {


        if (self.isDragging == false) {
          var tooltip = '<div class="tooltipevent panel panel-default" align="center" ' +
            'style="width:260px;height:185px;position:absolute;' +
            'z-index:10001;border-radius: 6px;box-shadow: 1px 1px 5px"' +
            '><div class="panel-heading"><strong>' + calEvent.Title + '</strong></div><div class="panel-body"><pre style="overflow:hidden;display:block;">' +
            'Kunde: ' + calEvent.Customer + '</pre><pre style="overflow: hidden;display:block;">' +
            'Planlagte timer: ' + calEvent.CalcEstimate + ' timer</pre></div></div>';
          $('body').append(tooltip);
          $(this).mouseover(function (e) {
            $(this).css('z-index', 10000);
            $('.tooltipevent').fadeIn('500');
            $('.tooltipevent').fadeTo('10', 1.9);
          }).mousemove(function (e) {
            $('.tooltipevent').css('top', e.pageY + -200);
            $('.tooltipevent').css('left', e.pageX + -100);
          });
        }
      },


      eventMouseout: function (calEvent, jsEvent) {
        $(this).css('z-index', 8);
        $('.tooltipevent').remove();
      },

      eventDragStart: function (event, jsEvent, ui, view) {
        self.setDragging(true);
        self.draggingElement = event;
      },

      eventRender: function (event, element) {
        element.bind('dblclick', function () {

          self.taskservice.getTask(event.TaskRef).subscribe(x => self.openModal(x));

        });
        if (event.Icon) {
          element.find('.fc-content').prepend('<i style=\'color: #8b0000;  text-shadow: 0px 0px 3px #FFFFFF; margin-left: 3px;\' class=\'fa fa-' + event.Icon + '\'></i>');
        }
      }
    });


    // Set specific view and datetime
    /*if(this.firstRun && this.defaultView != null && this.calendarDate != null)
    {
      $('#calendar').fullCalendar('changeView', this.defaultView);
      $('#calendar').fullCalendar('gotoDate', this.calendarDate);
      this.firstRun = false;
    }*/


    // Checks if the dragged event is over the external event list.
    var isEventOverDiv = function (x, y) {

      var external_events = $('#external-events');
      var offset = external_events.offset();
      offset.right = external_events.width() + offset.left;
      offset.bottom = external_events.height() + offset.top;

      // Compare
      if (x >= offset.left
        && y >= offset.top
        && x <= offset.right
        && y <= offset.bottom) {
        return true;
      }
      return false;
    };

    var placeEventInCalendar = function (copiedEventObject, timeplanNo) {

      copiedEventObject.TimePlanRef = timeplanNo;
      copiedEventObject.ResourceRef = self.chosenEmployee.No;
      // render the event on the calendar
      // the last `true` argument determines if the event "sticks" (http://arshaw.com/fullcalendar/docs/event_rendering/renderEvent/)
      $('#calendar').fullCalendar('renderEvent', copiedEventObject, true);

      // is the "remove after drop" checkbox checked?
      if ($('#drop-remove').is(':checked')) {
        // if so, remove the element from the "Draggable Events" list
        $(this).remove();
      }
    };

    // This function is called on every external event in the list.
    $('#external-events .fc-event').each(function () {

      // create an Event Object (http://arshaw.com/fullcalendar/docs/event_data/Event_Object/)
      // it doesn't need to have a start or end

      var eventObject = {
        title: $.trim($(this).text()), // use the element's text as the event title
        TaskRef: $(this).children('.taskRef').val(),
        stick: false
      };

      // store the Event Object in the DOM element so we can get to it later
      $(this).data('eventObject', eventObject);

      // make the event draggable using jQuery UI
      $(this).draggable({
        zIndex: 999,
        revert: true,      // will cause the event to go back to its
        revertDuration: 0  //  original position after the drag
      });
    });
  }

  toggleList(toggledList) {
    this.listToShow = toggledList;
  }

  setDragging(value: boolean) {
    this.isDragging = value;
  }
}

/*@Pipe({
  name: 'SearchPipe'
})
export class SearchPipe implements PipeTransform {
  transform(items: any[], str): any
  {
    if (str === undefined || str === '') return items;
    console.log("Str is : ");
    console.log(str);
    let filtered = [];

    //words = str.replace(" ", "|");

    let words = str.replace(new RegExp(" ", 'g'), "|");

    let rgx = new RegExp(words, 'gi');

    items.forEach(item => {
      item.points = (JSON.stringify(item).match(rgx) || []).length;
      if (item.points > 0) filtered.push(item);
    });

    return filtered;
  }
}*/








// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/controllers/calendars/full-calendar/full-calendar-view.component.ts